import { isProduction } from '../../data/constants.ts';
import '../overlays/as-tooltip.ts';

/**
 * <as-param-warning>
 * 
 * Standardized warning indicator for missing Paramate parameters.
 * Only renders its content if is-missing is true and not in production.
 */
export class AsParamWarning extends HTMLElement {
  static readonly tag = 'as-param-warning' as const;

  static get observedAttributes() {
    return ['trcad-param', 'is-missing'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    const isMissing = this.hasAttribute('is-missing') && this.getAttribute('is-missing') !== 'false';
    const paramName = this.getAttribute('trcad-param') ?? 'unknown';

    if (!isMissing || isProduction) {
      this.shadowRoot!.innerHTML = '';
      return;
    }

    this.shadowRoot!.innerHTML = `
      <style>
        :host {
          display: inline-block;
          vertical-align: middle;
          margin-left: 4px;
        }
        .warning-icon {
          color: #d9534f;
          font-weight: bold;
          cursor: help;
          border: 1px solid #d9534f;
          border-radius: 50%;
          width: 14px;
          height: 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
        }
      </style>
      <as-tooltip-wrapper placement="top" show-on-hover dict-key="paramWarning.notFound">
        <span class="warning-icon">!</span>
      </as-tooltip-wrapper>
    `;

    // Set via properties rather than inline HTML attributes so the param
    // name can't break out of the markup if it ever contains quotes.
    const wrapper = this.shadowRoot!.querySelector('as-tooltip-wrapper')!;
    wrapper.setAttribute('default-text', `Parameter '${paramName}' not found in configurator`);
    wrapper.setAttribute('vars', JSON.stringify([paramName]));
  }
}

if (!customElements.get(AsParamWarning.tag)) {
  customElements.define(AsParamWarning.tag, AsParamWarning);
}
